import { MedicationDays } from 'types/medication';

export const USER_LOGGED_IN_COUNT = 'login-count';
export const DAYS: MedicationDays[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const SOMETHING_WENT_WRONG = 'Something went wrong, please try again.';
export const UNABLE_TO_CREATE_USER = 'Unable to create user.';
export const UNABLE_TO_SUBMIT_QUESTIONNAIRE = 'Unable to submit questionnaire.';
export const UNABLE_TO_SUBMIT_MAP_REQUEST = 'Unable to submit map request right now. Please try again later from the app.';
export const SESSION_EXPIRED = 'Session expired, please login';
export const GEARING_UP_TO_SUPPORT_YOU = 'Please wait while we are gearing up to support you.';
export const SUPPORT_EMAIL_ADDRESS = 'support@mantacares.com';
export const DIAGNOSIS = 'Diagnosis';
export const TYPE_OF_CANCER = 'Type of cancer';
export const CANCER_SUB_TYPE = 'Cancer sub-type';
export const AGE_GROUP = 'Age group';
export const ETHINICITY = 'Ethnicity';
export const CANCER_TYPE = 'Cancer Type';
export const VIEW = 'View';
export const MAP = 'map';
export const PREVIOUS = 'Previous';
export const NEXT = 'Next';
export const DONE = 'Done';
export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const OKAY = 'Okay';
